import React from 'react';
import classNames from 'classnames';
import Immutable, { Map } from 'immutable';
import { ImageFromField, Paragraph } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  DEFAULT_LANGUAGE,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../../config/constants';
import { NodeEvent } from '../../../../types/nodes';
import { Breadcrumbs } from '../../../../components';
import EventMetaData from '../../../../components/EventMetaData';

interface EventPageProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeEvent>;
}

const EventPage: React.FC<EventPageProps> = ({ entity }) => {
  const classes = classNames('NodeEventPage');
  const event = entity.toJS();
  const title = event.title[0].value;
  const media = event.field_media_item;
  const body = event.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="u-flipped u-flipped--vertical">
          {media && (
            <div className="hero hero--small">
              <div className="field field--name-field-hero field--type-entity-reference field--label-hidden field__item">
                <article className="media media--type-image media--view-mode-crop-hero-small">
                  <ImageFromField
                    className="media__image"
                    field={Immutable.fromJS(event.field_media_item[0])}
                    imageStyles={Map({
                      [SCREEN_MOBILE]: 'cropped_standard_medium_viewport',
                      [SCREEN_TABLET]: 'cropped_standard_medium_viewport',
                      [SCREEN_NORMAL]: 'cropped_standard_medium_viewport',
                      [SCREEN_WIDE]: 'cropped_standard_large_viewport',
                    })}
                    lazyload
                  />
                </article>
              </div>
            </div>
          )}

          <div className="o-page-intro o-background--grey">
            <div className="o-page-intro__inner">
              <h1 className="small">{title}</h1>
              <EventMetaData event={entity.toJS()} />
            </div>
          </div>
        </div>

        <div className="breadcrumb-wrapper breadcrumb-wrapper--hero">
          <Breadcrumbs includeCurrent noBorders />
        </div>


        <div className="u-margin--top--9">
          {body ? (
            <div className="u-indent--large text-large p u-color-black u-margin--bottom--9">
              <div className="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item text-large">
                <WysiwygField
                  property="schema:text"
                  html={body}
                  // @ts-ignore
                  // eslint-disable-next-line react/no-unstable-nested-components
                  customElementHandler={(element: any) => {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (element.name === 'p') {
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                      return <p className="text-large">{ element.children[0].data }</p>;
                    }
                    return null;
                  }}
                />
              </div>
            </div>
          ) : null}
          {event.field_paragraphs ? (
            <div className="NodeEventPage__paragraphs">
              {event.field_paragraphs.map(({ target_id: id, entity: paragraph }) => {
                const language = paragraph.langcode[0].value || DEFAULT_LANGUAGE;

                return (
                  <div className={paragraph.type[0].target_id !== 'video' ? 'u-indent--large Paragraph' : 'Paragraph'}>
                    <Paragraph
                      key={`paragraph:${id}:${language}`}
                      id={id}
                      entity={Immutable.fromJS(paragraph)}
                    />
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>

      </Container>
    </article>
  );
};

export default EventPage;
